import logo from "./lexa_logo_m.png";
import Header from "./Components/Header/Header";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { PrivacyPolicies } from "./Components/PrivacyPolicies/PrivacyPolicies";
import { TermsAndCondition } from "./Components/TermsAndConditions/TermsAndConditions";

import "./App.scss";

const App = () => {
  return (
    <Router>
      <div className="App">
        <Header />
        <Switch>
          <Route path="/privacy-policy/:policy">
            <PrivacyPolicies />
          </Route>
          <Route path="/terms-and-conditions/:toc">
            <TermsAndCondition />
          </Route>
          <Route path="/" exact>
            <div className="App-header">
              <img src={logo} className="App-logo" alt="logo" />
              <p
                style={{
                  color: "gray",
                  margin: "0px",
                  borderTop: "1px solid white",
                  paddingLeft: "calc(50px - 5vmin)",
                  paddingRight: "calc(50px - 5vmin)",
                }}
              >
                Website under maintainence.
              </p>
              <small
                onClick={() => (location.href = "https://www.joeljaimon.com")}
                id="dot"
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  bottom: 10,
                  color: "whitesmoke",
                }}
              >
                <span
                  className="blink"
                  style={{
                    fontSize: 20,
                    fontWeight: 800,
                    color: "#9d77e2",
                  }}
                >
                  .
                </span>
                Developer Portfolio
              </small>
            </div>
          </Route>
        </Switch>
      </div>
    </Router>
  );
};

export default App;
